

import React from 'react'
import { updateChatQuestion } from '../../../features/aiControl/aiControlSlice'


import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import PageTopTitle from '../../shared/PageTopTitle'

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 700px;
        max-height: 600px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        padding-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .content{
            width: 100%;
            padding: 30px;
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            min-height: 400px;
            overflow: auto;
            margin-bottom: 90px;
            
            .question-item{
                display: flex;
                flex-direction: column;
                width: 100%;
                gap: 5px;
                padding: 10px 40px;

                textarea{
                    border: 2px solid ${({theme}) => theme.mainBorderColor};
                    padding: 10px;
                    font-size: var(--font-size-sm);
                    border-radius: 10px;
                    max-height: 360px;
                    resize: vertical;
                    font-variant-numeric: lining-nums;
                    margin-bottom: 10px;
                    line-height: 1.4;

                    &::placeholder{
                        font-weight: var(--font-weight-lg);
                        color: ${({theme}) => theme.mainTextColor};
                    }
                    &:last-of-type{
                    min-height: 360px;

                    }
                }

                span{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                }
            }

            .activity-container{
                width: 100px;
                border: 2px solid ${({theme}) => theme.mainBorderColor};
                border-radius: 10px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 10px 15px;
                margin-top: 10px;
                cursor: pointer;


                .activity-top{
                    width: 12px;
                    height: 12px;
                    border-radius: 50%;
                }

                .active{
                    background-color: var(--color-green);
                }

                .passive{
                    background-color: var(--color-main);
                }
            }

            
        }
        .btn-container{
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            height: 70px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 20px;
            border-top: 1px solid ${({theme}) => theme.mainTextColor};
        }
    }
`


const UpdateAiSingleQuestionItemModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)

    const { lockScroll, unlockScroll } = useScrollLock();

    const {questionItemData} = useSelector(state => state.aiControl)

    const [questionData, setQuestionData] = useState(questionItemData)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleSubmit = () => {

        dispatch(updateChatQuestion({
            aidefaultMesssages: [questionData]
        }))
    }


  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <PageTopTitle title={"Soru Güncelle"}/>
        <div className="content">
            <div className="question-item">
                <span>Soru</span>
                <textarea value={questionData.question} onChange={(e) => setQuestionData({...questionData, question: e.target.value})}></textarea>
                <span>Cevap</span>
                <textarea value={questionData.answer} onChange={(e) => setQuestionData({...questionData, answer: e.target.value})}></textarea>
                <div className="activity-container" onClick={() => setQuestionData({...questionData, isActive: !questionData.isActive})}>
                    <span>{questionData.isActive ? "Aktif" : "Pasif"}</span>
                    <span className={questionData.isActive ? "activity-top active": "activity-top passive"}/>
                </div>
            </div>
        </div>
        <div className="btn-container">
            <Btn width={"200px"} bgColor="#E85446" height="40px" color="#fff" handleClick={handleSubmit}>Tamamla</Btn>
            <Btn width={"200px"} bgColor="#E85446" height="40px" color="#fff" handleClick={() => dispatch(showModal(null))}>Vazgeç</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default UpdateAiSingleQuestionItemModal